import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { Instagram } from "lucide-react";
import Header from "@/components/essex/Header";
import Footer from "@/components/essex/Footer";
import { InstagramSection } from "@/components/essex/InstagramSection";
import { SecureDateCTA } from "@/components/essex/SecureDateCTA";

export default function RealWeddings() {
  return (
    <div data-testid="real-weddings-page" className="bg-[#0A0908] min-h-screen">
      <Helmet>
        <title>Real Weddings | Behind the Scenes with Wedding Video Essex</title>
        <meta name="description" content="Go behind the scenes with Wedding Video Essex. See real moments from real weddings across Essex. No posing, no setups, just honest wedding photography and videography." />
        <link rel="canonical" href="https://essex.weddingvideo.co.uk/real-weddings" />
      </Helmet>
      <Header />

      {/* Hero */}
      <section className="pt-24 pb-12 md:pt-32 md:pb-16">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <div className="flex items-center justify-center gap-2 mb-6">
              <Instagram className="w-4 h-4 text-[#C2A878]" />
              <p className="text-xs tracking-[0.2em] uppercase text-[#C2A878] font-sans">
                @WeddingVideoEssex
              </p>
            </div>
            <h1
              data-testid="real-weddings-heading"
              className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl tracking-tighter font-light text-[#F5F5F0] leading-[1.1]"
            >
              Behind the <em className="italic text-[#C2A878]">Scenes</em>
            </h1>
            <p className="mt-6 text-base md:text-lg text-[#A19D94] font-sans leading-relaxed max-w-xl mx-auto">
              This is what your wedding day looks like from our side.
              No posing. No setup shots. Just us doing our thing while
              you enjoy the best day of your life.
            </p>
            <a
              href="https://instagram.com/WeddingVideoEssex"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="real-weddings-instagram-link"
              className="mt-6 inline-flex items-center gap-2 px-6 py-3 border border-[#C2A878]/30 text-sm text-[#C2A878] font-sans tracking-wide hover:bg-[#C2A878]/10 transition-all duration-300"
            >
              <Instagram size={16} />
              Follow us on Instagram
            </a>
          </motion.div>
        </div>
      </section>

      {/* Full Instagram Grid */}
      <InstagramSection showAll />

      {/* CTA */}
      <SecureDateCTA
        heading="Want us at your wedding?"
        subtext="We only take a limited number of weddings each month. Pop your details in and we'll check if your date is free."
      />

      <Footer />
    </div>
  );
}
